/**
 * Cdn Name Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cdnNameFormatter = function(value, row) {
    let domain_id = $('#domain_id').val();
    if (row.id && row.original_type === "directory" && value) {
        return '<a href="/domains/show/cdn/'+domain_id+'?uuid='+row.uuid+'">'+value+"</a>";
    } else if (value) {
        return value;
    }
};
